<template>
    <form-creative-default-inputs>
        <div class="col-12">
            <q-input
                v-model="formCreativeData.description"
                type="text"
                label="Texto *"
                maxlength="254"
                :rules="[
                    isRequired,
                    (val) => val.length < 254 || $t('character_limit_254'),
                ]"
                outlined
            />
        </div>
        <div class="col-12">
            <q-input
                v-model="formCreativeData.destination_url"
                type="url"
                :label="$t('redirect_url') + ' *'"
                :rules="[isRequired]"
                outlined
                autogrow
            >
                <template v-slot:append>
                    <q-icon
                        name="mdi-help-circle-outline"
                        class="cursor-pointer"
                        size="1.3em"
                        color="primary"
                        @click="onShowMacros"
                    >
                        <q-tooltip
                            content-class="bg-secondary text-white"
                            content-style="font-size: 12px"
                        >
                            Macros
                        </q-tooltip>
                    </q-icon>

                    <MacroListCreative
                        :showM="showMacros"
                        @closemacro="showMacros = false"
                    />
                </template>
            </q-input>
        </div>
    </form-creative-default-inputs>
</template>

<script>
import MacroListCreative from "./MacroListCreative.vue";
import FormCreativeDefaultInputs from "./FormCreativeDefaultInputs.vue";
import CreativeMixin from "@m/CreativeMixin.js";

export default {
    name: "DealCretive",
    components: { MacroListCreative, FormCreativeDefaultInputs },
    mixins: [CreativeMixin],
    data() {
        return {
            showMacros: false,
        };
    },
    methods: {
        onShowMacros() {
            this.showMacros = !this.showMacros;
        },
    },
};
</script>
